import { replaceWithOptionalTranslation } from "./replace_with_optional_translation";

const TRANSLATION_KEY_PREFIX = 'manufacturer';

export function replaceWithOptionalManufacturerTranslation(
    manufacturer,
) {
    return replaceWithOptionalTranslation(manufacturer, manufacturer, TRANSLATION_KEY_PREFIX);
}
